/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Convo'>;
const hooks = useModelQueries(schema, 'Convo');

export const useAggregateConvo: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountConvo: Hooks['useCount'] = hooks.useCount;
export const useCreateConvo: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyConvo: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnConvo: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteConvo: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyConvo: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsConvo: Hooks['useExists'] = hooks.useExists;
export const useFindFirstConvo: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyConvo: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueConvo: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByConvo: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyConvo: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateConvo: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountConvo: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstConvo: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyConvo: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueConvo: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByConvo: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyConvo: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateConvo: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyConvo: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnConvo: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertConvo: Hooks['useUpsert'] = hooks.useUpsert;
